class ZoomImage extends HTMLElement {
  constructor() {
    super();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  get imageElement() {
    return (
      this._imageElement || (this._imageElement = this.querySelector("img"))
    );
  }
  get videoElement() {
    return (
      this._videoElement ||
      (this._videoElement = this.querySelector("slider-video"))
    );
  }

  getDimensions() {
    return {
      width: this.imageElement.clientWidth,
      height: this.imageElement.clientHeight,
    };
  }

  setupZoom() {
    if (this.wzoom) {
      return;
    }

    let isGrabbing = false;
    const setCursor = () => {
      if (!this.wzoom) {
        return;
      }
      this.imageElement.style.cursor =
        this.wzoom._computeScale() > 1
          ? isGrabbing
            ? "grabbing"
            : "grab"
          : "zoom-in";
    };

    const dimensions = this.getDimensions();
    this.wzoom = WZoom.create(this.imageElement, {
      width: dimensions.width,
      height: dimensions.height,
      minScale: 1,
      maxScale: 3,
      prepare: setCursor,
      rescale: setCursor,
      onDrop: (zoom) => {
        isGrabbing = false;
        setCursor(zoom);
      },
      onGrab: (zoom) => {
        isGrabbing = true;
        setCursor(zoom);
      },
    });

    setCursor();

    this.handleTouchStart = this.preventPageZoom.bind(this);
    this.imageElement.addEventListener("touchstart", this.handleTouchStart);

    this.resizeObserver = new ResizeObserver(this.updateDimensions.bind(this));
    this.resizeObserver.observe(this);
  }

  preventPageZoom(event) {
    if (event.touches.length === 2) {
      event.preventDefault(); // Override pinch-to-zoom on image
    }
  }

  cleanup() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.wzoom) {
      this.wzoom.destroy();
      this.wzoom = null;
    }
    if (this.handleTouchStart) {
      this.imageElement.addEventListener("touchstart", this.handleTouchStart);
    }
  }

  updateDimensions() {
    if (!this.wzoom) {
      return;
    }
    const dimensions = this.getDimensions();
    this.wzoom.options.width = dimensions.width;
    this.wzoom.options.height = dimensions.height;

    this.wzoom.prepare();
  }

  playVideo() {
    if (this.videoElement) {
      this.videoElement.play(true);
    }
  }

  show() {
    if (this.dataset.mediaType === "video") {
      return this.playVideo();
    }

    if (this.wzoom) {
      this.updateDimensions();
      this.wzoom.transform(0, 0, 1);
      return;
    }

    const isLoaded =
      this.imageElement.complete && this.imageElement.naturalHeight !== 0;

    if (isLoaded) {
      this.setupZoom();
    } else {
      this.imageElement.addEventListener(
        "load",
        () => {
          this.setupZoom();
        },
        { once: true }
      );
    }
  }

  hide() {
    if (this.dataset.mediaType === "video" && this.videoElement) {
      this.videoElement.pause();
    }
  }
}
customElements.define("zoom-image", ZoomImage);
